import { render } from "./Or_map.vue?vue&type=template&id=095689b7&scoped=true&ts=true"
import script from "./Or_map.vue?vue&type=script&lang=ts"
export * from "./Or_map.vue?vue&type=script&lang=ts"

import "./Or_map.vue?vue&type=style&index=0&id=095689b7&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-095689b7"]])

export default __exports__